import './nav.less';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import NavigationItem from './nav-item';

const b = block('nav');

class Navigation extends Component {
	render() {
		const {items, className} = this.props;

		return (
			<div className={b({}, className)}>
				{items.map((item, index) => (
					<NavigationItem key={item + index} index={index} {...item} />
				))}
			</div>
		);
	}
}

Navigation.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/header/nav/index.jsx